import { RestError } from "../../services/rest-service/RestService";
import { useMutation, useQueryClient } from "react-query";
import { IUserActivityLogItem } from "../../services/user-activity-log-service/Models";
import UserActivityLogService from "../../services/user-activity-log-service/UserActivityLogService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";

export type UseLogUserActivityParameters = {
    customerID: number,
} & BaseUseMutationParameters<void, IUserActivityLogItem>;

export function useLogUserActivity({
    customerID,
    offline,
    onError,
    onSuccess
}: UseLogUserActivityParameters) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, IUserActivityLogItem>(
        (logItem) => {
            return UserActivityLogService.logUserActivity(
                customerID,
                logItem,
                offline ?? false
            );
        },
        {
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, _error, _runTicket, _context) => {
                queryClient.invalidateQueries(keys.all);
            }
        }
    );
}